import React from 'react'
import { usePricingVersionCache, useUniqueJobCodeKeys, useUpdatePricingVersion, useVersionRulesCache } from '../../../../../hooks/global-job-matching'
import { useParams } from 'react-router'
import { Group, Stack, Text, Title } from '@mantine/core'
import { RadioCard, SearchablePillInput } from '../../../../common'
import { MatchStrategy, PropagateMatchOption } from '../../../GlobalJobMatchingVersioning/types/versions'

export const PropagateMatches = () => {
  const params = useParams<{ id: string }>()
  const version = usePricingVersionCache(params.id)
  const rules = useVersionRulesCache(params.id)
  const { data: jobCodeKeys } = useUniqueJobCodeKeys(params.id)
  const { mutate: updateVersion } = useUpdatePricingVersion(params.id)

  const updateJobCodeKeys = (newValues: string[]) => updateVersion({ propagateMatchJobSelection: newValues })

  if (version.matchStrategy !== MatchStrategy.FILE || !version.shouldPropagate || rules.jobsSelection !== 'all') return

  return (
    <Stack>
      <Title order={2} style={{ fontWeight: 600 }}>Propagate Upload Match Priorities</Title>
      <Text>
        Use the counterpart matches for jobs with the same job code but different job code key. 
        Survey data cut priority levels must be set in order to propagate the matches.
      </Text>
      <Group wrap='nowrap'>
        <RadioCard
          label='Propagate to all other jobs'
          h={66}
          w={300}
          checked={version?.propagateMatchOption === PropagateMatchOption.ALL}
          onClick={() => updateVersion({ propagateMatchOption: PropagateMatchOption.ALL })}
        />
        <RadioCard
          label='To selected jobs'
          h={66}
          w={300}
          checked={version?.propagateMatchOption === PropagateMatchOption.SELECT_JOBS}
          onClick={() => updateVersion({ propagateMatchOption: PropagateMatchOption.SELECT_JOBS })}
        />
      </Group>
      { version?.propagateMatchOption === PropagateMatchOption.SELECT_JOBS &&
        <SearchablePillInput
          items={jobCodeKeys || []}
          selected={version?.propagateMatchJobSelection || []}
          onSelect={updateJobCodeKeys}
          onRemove={updateJobCodeKeys}
          placeholder='Select job code keys'
          nothingFoundMessage='No job code keys found...'
        />
      }
    </Stack>
  )
}
